<template>
  <div class="container-top-influencers">
    <div>
      <div class="container-top-influencers-title">
        <img src="/chat.svg" alt="chat" />
        <span class="top-influencers-title"> Top Influenciadores </span>
      </div>
    </div>
    <CustomSkeleton
      v-if="isSearching"
      :listWidth="{ firstLine: '400px', secondLine: '300px' }"
      :listHeight="{ thirdLine: '100px' }"
      type="list"
    />
    <span v-if="topInfluencers.length === 0 && !isSearching" class="no-data-text">
      Não há top influencers nessa data.
    </span>
    <DataTable
      v-if="!isSearching"
      :value="topInfluencers"
      responsive-layout="scroll"
      style="margin-top: 30px"
    >
      <div v-if="topInfluencers.length > 0">
        <Column header="Nome de usuário" field="name">
          <template #body="rowData">
            <div class="top-influencers-table-row-name">
              <span>
                <i class="pi pi-instagram" style="font-size: 1rem; color: #64b4c8" />
              </span>

              <!-- <span v-if="rowData.data.socialMedia === 'facebook'">
              <i class="pi pi-facebook" style="font-size: 1rem; color: #64b4c8" />
            </span>

            <span v-if="rowData.data.socialMedia === 'twitter'">
              <i class="pi pi-twitter" style="font-size: 1rem; color: #64b4c8" />
            </span> -->
              <span @click="handleRedirectToInstagram(rowData.data.name)" style="cursor: pointer">{{
                rowData.data.name
              }}</span>
            </div>
          </template>
        </Column>
        <Column header="Seguidores" field="followers_count" />
      </div>
    </DataTable>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import CustomSkeleton from '@/Shared/CustomSkeleton'

export default {
  props: {
    isSearching: Boolean,
    topInfluencers: Array,
  },
  components: {
    DataTable,
    Column,
    CustomSkeleton,
  },
  methods: {
    handleRedirectToInstagram(influencer) {
      window.open(`https://instagram.com/${influencer}`)
    },
  },
}
</script>

<style lang="scss" src="./styles.scss"></style>
